// Presentatiehulp voor het org-beleid "audio verwijderen na verwerking".
// Los van de component zodat de afronding testbaar is zonder React — zelfde
// opzet als tierModeLabels.ts hiernaast.

/**
 * "1 min" / "24 u" / "7 d" — de drie presets uit de modal, kort genoeg voor de
 * tag in de organisatielijst. Minder dan een uur blijft in minuten; één dag
 * leest als "24 u" (zoals de preset heet), vanaf twee dagen in dagen; alles wat
 * geen hele dag of heel uur is, valt terug op minuten.
 */
export function formatAudioRetention(minutes: number): string {
  if (minutes < 60) return `${minutes} min`;
  if (minutes % 1440 === 0 && minutes >= 2880) return `${minutes / 1440} d`;
  if (minutes % 60 === 0) return `${minutes / 60} u`;
  return `${minutes} min`;
}
